$(function () {
    // lb-imageBox
    if ($('.lb-imageBox').length) {
        if ($().matchHeight) {
            $('.lb-imageBox_header').matchHeight();
        }

        // unwrap lb-imageBox that has no link
        $('.fbg-row.lb-imageBox a').each(function() {
            if ($(this).attr('href') === '' || $(this).attr('href') === '#' || !$(this).attr('href')) { // don't style link
                $(this).contents().unwrap('a');
            }
        });
    }

    // lb-callToAction
    if ($('.lb-callToAction').length) {
        if ($().matchHeight) {
            $('.lb-callToAction_contentWrapper').matchHeight();
        }
    }

    // lb-carousel
    if ($('.lb-carousel').length) {
        $('.lb-carousel').each(function () {
            var flickityData = JSON.stringify($('.lb-carouselContainer', this).attr('data-flickity'));
            var objflickityData = $.parseJSON(flickityData);

            if (!objflickityData['contain']) {
                $(this).addClass('containFalse');
            }
        });
    }
});

$(window).load(function () {
    // lb-carousel
    if ($('.lb-carousel.containFalse').length
        && (!iCreateObject.isSiteInICreateMode || iCreateObject.isSiteInPreviewMode)) {
        triggerResizeEvent();
    }

    if ($('#uber.edit-mode').length) {
        if ($('.lb-carousel').length) {
            setTimeout(function () {
                $('.lb-carousel .lb-carouselContainer').flickity('stopPlayer');
            }, 1000);
        }
    }
});
